import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrame } from "../src/util";

// Start initializing the API without blocking module execution, so the click
// listeners below are always bound. Each listener awaits `apiReady`, so a click
// made before the API is ready queues instead of being silently dropped.
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrame(myframe)
  .then((api) => {
    LwAPI = api;
    LwAPI.applyConfig({ showPMI: false }); // Hide PMI by default
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

// Transformation matrix: Rotate -90 deg around X axis and move -60, +70, -45 in x/y/z direction
var tmat = [1, 0, 0, 0, 0, 0, -1, 0, 0, 1, 0, 0, -60, 70, -45, 1];

function ex_add(p: string, trafo?: number[]) {
  LwAPI?.addModel(p, trafo).then(function (result) {
    if (result.error !== null) alert(result.msg);
  });
}

function ex_close(p: string) {
  LwAPI?.closeModel(p).then(function (result) {
    if (result.error !== null) alert(result.msg);
  });
}

// Bind functions to buttons
document.getElementById("add-measure")?.addEventListener("click", async () => {
  await apiReady;
  ex_add("Measurement.jt");
});
document.getElementById("add-flange")?.addEventListener("click", async () => {
  await apiReady;
  ex_add("Flange.jt");
});
document.getElementById("close-flange")?.addEventListener("click", async () => {
  await apiReady;
  ex_close("Flange.jt");
});
document
  .getElementById("add-flange-rot")
  ?.addEventListener("click", async () => {
    await apiReady;
    ex_add("Flange.jt", tmat);
  });
